import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BrowserUtils from '../../utils/BrowserUtils';
import StepHeader from '../../includes/StepHeader';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';
import HelpStore from '../../stores/HelpStore';
import InternetBankingActions from '../../actions/InternetBankingActions';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';

let faqUrl;
let urlLink;

class AnyQuestions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      iframe: BrowserUtils.isMobileView()
        ? '<iframe id="iframe" width="auto" height="auto" style="width: 100%; height: 100%; border: 0;" src={url} ></iframe>'
        : '<iframe id="iframe" width="auto" style="border: 0; width: 100%; height: calc(100vh - 122px);" src={url} height="auto" cellspacing="5" id="iframe"></iframe>',
      length: window.history.length,
      previousButtoncss:
        'c-btn c-btn--link c-btn--link-icon c-step-header__control',
      nextButtoncss:
        'c-btn c-btn--link c-btn--link-icon c-step-header__control',
      backClick: 0,
      name: 'load',
    };
    this.iframe = this.iframe.bind(this);
    this.refresh = this.refresh.bind(this);
    this.back = this.back.bind(this);
    this.forward = this.forward.bind(this);
    this.onIframeClick = this.onIframeClick.bind(this);
    this.goBackToLastActivity = this.goBackToLastActivity.bind(this);
  }

  componentDidMount() {
    sayLandingMessage(this.props.content.anyQuestionsHeading);
  }

  onIframeClick() {}

  back() {
    if (this.state.length !== window.history.length - this.state.backClick) {
      window.history.go(-1);
      this.setState({ backClick: this.state.backClick + 1 });
    }
  }

  forward() {
    window.history.forward();
    if (this.state.backClick > 0) {
      this.setState({ backClick: this.state.backClick - 1 });
    }
  }

  goBackToLastActivity() {
    const urlString = HelpStore.getBackUrl().data;
    urlString !== '' && InternetBankingActions.navigateToWebTask(urlString);
  }

  // iframe renders.
  iframe() {
    urlLink = HelpStore.getBackUrl().urlLink;
    faqUrl = this.state.iframe.replace('{url}', urlLink);
    return {
      __html: faqUrl,
    };
  }

  // OnClick Refresh the iframe.
  refresh() {
    document.getElementById('iframe').setAttribute('src', urlLink);
  }

  render() {
    return (
      <div className="bow page layout any-questions-page-template">
        {/* <span id="accessH1ID" tabIndex="0" className="u-visually-hidden off-screen" ref="accessibilityHeading">You are on Any Questions Page </span> */}
        <div className="layout__inner">
          <div className="container" id="site-main" role="main" tabIndex="-1">
            <div className="row">
              <div className="col-xl1-24">
                <StepHeader
                  showheaderCrumbs
                  onClick={this.goBackToLastActivity}
                  headerCrumbsMessage="Back"
                  headerTitle={this.props.content.anyQuestionsHeading}
                  showControl
                  controlBack={this.back}
                  controlForward={this.forward}
                  controlRefresh={this.refresh}
                />
                <div
                  className="any-question__container"
                  dangerouslySetInnerHTML={this.iframe()}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AnyQuestions.propTypes = {
  content: PropTypes.object,
  closed: PropTypes.func,
};

AnyQuestions.propTypes = {
  content: {},
};

export default RequiresAuthenticatedUser(AnyQuestions);
